import { createContext } from 'utils/react-helpers';

const [ProgressBarContext, useProgressBar] = createContext({
  name: 'ProgressBarContext',
});

export { ProgressBarContext, useProgressBar };
